module.exports = __webpack_public_path__ + "static/media/IntelligentOpportunityMiner.257f0bf2.png";